export default __webpack_public_path__ + "static/media/20.a41b0d96.jpg";